var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.6C2 3.26863 2.26863 3 2.6 3H4.16804C4.3173 3 4.4612 3.05563 4.57164 3.15604L5.32836 3.84396C5.4388 3.94437 5.5827 4 5.73196 4H13.4C13.7314 4 14 4.26863 14 4.6V12.4C14 12.7314 13.7314 13 13.4 13H2.6C2.26863 13 2 12.7314 2 12.4V3.6Z",
    fill: "#E0B100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesFolder);
export default __webpack_public_path__ + "static/media/files-folder.b8a6239f72ccf7c9450cb407e0990f52.svg";
export { ForwardRef as ReactComponent };